import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=4ba99afd&scoped=true&"
import script from "./Change.vue?vue&type=script&lang=ts&"
export * from "./Change.vue?vue&type=script&lang=ts&"
import style0 from "./Change.vue?vue&type=style&index=0&id=4ba99afd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba99afd",
  null
  
)

export default component.exports